let React           = require("react");

let MemberHub       = require("../MemberHub.jsx");
let WrappedModalHub = require("./WrappedModalHub.jsx");
let InvitePeopleHub = require("../InvitePeopleHub.jsx");

class ManageMembersModalHub extends React.Component {

    constructor(){
        super();
    }

    render() {
        let { id, name:hubName, show, currentHubMembers, currentHubInvites, setLoading, setError, onClose, isView = false,
                setConfirmation, owner: {avatar, email, name, id:ownerId} = {avatar:"", email:"", name:""}, handleError
            } = this.props;
        let generalConfig = {hubName, setError, setLoading, setConfirmation, handleError};

        if(!currentHubMembers) currentHubMembers = [];
        if(!currentHubInvites) currentHubInvites = [];

        let members = [{avatar, email, name, state: "owner", id: ownerId}, ...currentHubMembers];

        return  <WrappedModalHub show={show} style="seventy" title={isView? "View Members": `${fullHubAlias} Members`} onClose={() => onClose("manage")} btnCancelText="Close">

                    <div className="manageMembersModalHub">
                        <div className="manageMembersModalHub__head">
                            <div className="manageMembersModalHub__head__name">Name</div>
                            <div className="manageMembersModalHub__head__email">Email</div>
                            <div className="manageMembersModalHub__head__status">Status</div>
                        </div>
                        <div className="manageMembersModalHub__container">
                            {members.map((member, index) => <MemberHub hubId={id}
                                                        key={`${member.email}-${index}`}
                                                        {...generalConfig}
                                                        isView={isView} {...member}
                                                    />)}

                            {currentHubInvites.map((invite, index) => <MemberHub hubId={id}
                                                        key={`${invite.email}-${index}`}
                                                        {...generalConfig}
                                                        type={"invite"} isView={isView} {...invite}
                                                    />)}
                        </div>
                    </div>

                    {!isView && <InvitePeopleHub {...this.props}
                                    id={id}
                                    setError={setError}
                                    members={members}
                                    invites={currentHubInvites}
                                    setLoading={setLoading}/>}

                </WrappedModalHub>
    }
}

module.exports = ManageMembersModalHub;
